<template>
  <div class="hello">
    <div style="width: 60%;display:inline-block;">
      <div style="display:flex;padding:10px 10px;font-size:20px;font-weight:bold;">{{msg}}</div>
      <div style="display: flex;padding:10px 10px;align-items:center;">
        <div style="flex: 0 0 120px;color:#888;font-size:16px;text-align:left;">请选择表情包</div>
        <div style="flex:1; text-align:left;">
          <emoji-icon @select="selectIcon" :iconConfig="iconConfig"></emoji-icon>
        </div>
      </div>
      <div style="padding-left:10px; padding-right:10px;">
        <div v-for="d in data" v-html="d" style="padding:10px 10px; border: 1px solid #ddd;margin-bottom:10px;"></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Use Vue2 Emoji Plugin',
      iconVal: '',
      iconConfig: {
        color: 'black'
      },
      data: []
    }
  },
  methods: {
    selectIcon (val) {
      this.data.push(val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue?228c9ed7